
import { Link } from 'react-router-dom';
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function PricingCTA() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <AnimatedSection animation="scale-in">
          <div className="bg-gray-950 rounded-3xl p-12 lg:p-16 text-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-emerald-500/5 rounded-full blur-3xl"></div>

            <div className="relative z-10">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
                ¿Listo para transformar tu<br /><span className="font-display italic text-emerald-400">óptica</span>?
              </h2>
              <p className="text-sm text-white/70 mb-8 max-w-lg mx-auto">
                Comienza tu prueba gratuita de 14 días. Sin tarjeta de crédito, sin compromiso. Implementación en 48 horas.
              </p>
              <div className="flex items-center justify-center space-x-4">
                <Link to="https://anamnesysoft.com/" className="px-8 py-3.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-all hover:shadow-lg hover:shadow-emerald-500/25 whitespace-nowrap cursor-pointer">
                  Registrarse / Ingresar
                </Link>
                <Link to="/#contacto" className="px-8 py-3.5 bg-white/10 text-white text-sm font-semibold rounded-lg border border-white/20 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
                  Contactar Ventas
                </Link>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
